// extracted by mini-css-extract-plugin
export default {"lastColumn":"styles-module__lastColumn__src-labstep-web-components-Entity-Table-BulkSelect-_crGvr"};